"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appTheme = exports.appOverrides = exports.typographyColors = exports.appColors = exports.appPalette = exports.SIGNATURIT_SELECTED_BUTTON = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@material-ui/core");
var _colors_1 = require("./commons/_colors");
var typography_1 = require("./typography");
exports.SIGNATURIT_SELECTED_BUTTON = '#E0E0F4';
exports.appPalette = {
    primary: {
        light: _colors_1.lightPrimary,
        main: _colors_1.primaryColor,
        dark: _colors_1.darkPrimary,
    },
    success: {
        main: _colors_1.successColor,
        dark: _colors_1.darkSuccess,
    },
    error: {
        main: _colors_1.dangerColor,
    },
    info: {
        light: _colors_1.lightInfo,
        main: _colors_1.infoColor,
        dark: _colors_1.darkInfo,
    },
};
exports.appColors = {
    white: _colors_1.white,
    lightBlue: _colors_1.lightBlue,
    darkerGrey: _colors_1.darkerGrey,
    darkMediumGrey: _colors_1.darkMediumGrey,
    lightGrey: _colors_1.lightGrey,
    darkPrimary: _colors_1.darkPrimary,
};
exports.typographyColors = {
    MuiTypography: {
        colorPrimary: {
            color: _colors_1.darkPrimary,
        },
        colorSecondary: {
            color: _colors_1.white,
        },
        colorTextPrimary: { color: _colors_1.darkSecondary },
        colorTextSecondary: { color: _colors_1.mediumBlue },
        colorError: { color: _colors_1.dangerColor },
    },
};
exports.appOverrides = tslib_1.__assign({ MuiListItem: {
        root: {
            '&[data-signa="sidebar-item"]': {
                '&$selected': {
                    backgroundColor: _colors_1.secondaryColor,
                },
            },
            '&$hover': {
                backgroundColor: _colors_1.secondaryHover,
            },
        },
    }, MuiDrawer: {
        paperAnchorLeft: {
            backgroundColor: _colors_1.lightSecondary,
        },
    }, MuiIconButton: {
        colorPrimary: { backgroundColor: _colors_1.primaryColor },
        root: {
            padding: '16px',
        },
    }, MuiButton: {
        containedPrimary: {
            color: exports.appColors.white,
            backgroundColor: _colors_1.primaryColor,
            borderRadius: 4,
            fontSize: 18,
            '&:hover': {
                backgroundColor: _colors_1.mediumPrimary,
            },
        },
        containedSecondary: {
            color: exports.appColors.darkPrimary,
            backgroundColor: _colors_1.lightSecondary,
            borderRadius: 4,
            '&:hover': {
                backgroundColor: _colors_1.secondaryHover,
            },
        },
    }, MuiCircularProgress: {
        colorPrimary: {
            color: _colors_1.brandPrimaryExtraDark,
        },
    }, MuiSnackbar: {
        root: {
            borderRadius: '8px',
        },
        anchorOriginTopCenter: {
            top: '16px',
            left: '16px',
            right: '16px',
        },
    } }, exports.typographyColors);
exports.appTheme = (0, core_1.createMuiTheme)({
    palette: exports.appPalette,
    colors: exports.appColors,
    overrides: exports.appOverrides,
    typography: typography_1.typography,
});
